import { send } from '../../../../../../../src/network';
import {
  OrderGroupingStatus,
  type OrderDetail,
  type OrderDetailWithSideloadedTags,
} from '../../../../../../../src/types/OrderDetail';
import { convertTagIdsToTags } from '../../../../../../../src/utils/convertTagIdsToTags';
export { StatusEnum as OrderStatus } from '../../../../../../../src/types/StatusEnum';
export { type Product } from '../../../../../../../src/types/Product';
export { OrderGroupingStatus, type OrderDetail };

type Params = {
  inventory_date?: string;
  orderId: number;
};

/**
 * Warning!!!!!
 *
 * This API call has a side effect of triggering a shuffle on the order that you're fetching if the order isn't already shuffled.
 *
 * This can lead to side effects of shuffling an order too early, like when we're still collecting onboarding information.
 *
 * Be very careful about where you use this API and, if you do use it, regression test the onboarding flow.
 */
export async function getCustomerOrder({ orderId }: Params) {
  const queryParams = new URLSearchParams();
  queryParams.set('sideload', 'tags');

  const response = await send<OrderDetailWithSideloadedTags>({
    path: `/api/v2/customers/self/orders/${orderId}/`,
    query: queryParams,
    method: 'GET',
  });

  const order = response.data.order?.[0];
  const tags = response.data.tags;

  const data: OrderDetail = {
    ...order,
    bundles: order.bundles.map((bundle) => {
      return {
        ...bundle,
        pairing:
          bundle.pairing === null
            ? null
            : {
                ...bundle.pairing,
                ingredients: bundle.pairing.ingredients.map((ingredient) => {
                  return {
                    ...ingredient,
                    tags: convertTagIdsToTags(ingredient.tags || [], tags),
                  };
                }),
                tags: convertTagIdsToTags(bundle.pairing.tags, tags),
              },
      };
    }),
    products: order.products.map((product) => {
      return {
        ...product,
        tags: convertTagIdsToTags(product.tags, tags),
      };
    }),
    promo_product: order.promo_product
      ? {
          ...order.promo_product,
          tags: convertTagIdsToTags(order.promo_product.tags, tags),
        }
      : null,
  };

  return {
    status: response.status,
    data,
  };
}
